module.exports = __webpack_public_path__ + "static/media/ReferencesIcon.f29121bd.svg";